import React from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { useQueryParamLang, useLanguage, useMe } from '../../hooks'
import { theme, setSize } from '../../style'
import Column from '../../components/common/Column'
import Circle from '../../components/common/Circle'
import Text from '../../components/common/Text'
import Icon from '../../components/common/Icon'
import Block from '../../components/common/Block'
import Button from '../../components/common/Button'
import Spacer from '../../components/common/Spacer'
import SplitFlapDisplay from '../../components/common/SplitFlapDisplay'
import ImageBackground from '../../components/common/ImageBackground'
import Globe from '../../components/forest/globe'
import Share from '../../components/social/share'

const MASK_SIZE = 60
const CIRCLE_SIZE = 84
const TREES_OFFSET = 0

const MainContainer = styled.div`
    display: flex;
    justify-content: center;
    background-color: ${theme.darkSlateBlue};
`

const ForestWidget = () => {

    const { puid } = useParams()
    const { lang } = useQueryParamLang()
    const { t } = useLanguage(lang)

    const [loadingInfo, error, medalInfo] = useMe({ puid })

    if (loadingInfo) {
        return (
            // TODO: add a nice loading component to be reused across widgets
            <Block alignItems="center">
                <Text>{t('loadingComp.title')}</Text>
            </Block>
        )
    }

    if (error || medalInfo == null) {
        return null
    }

    const {
        treesPlantedTribe,
        profile,
        invitationLink,
        invitedUsers,
    } = medalInfo || {}

    const shareContent = {
        title: 'Tribaldata',
        subject: t('forestWidget.shareContent.subject', { members: treesPlantedTribe }),
        message: t('forestWidget.shareContent.message', { members: treesPlantedTribe }),
        url: window.location.href,
    }

    return (
        <MainContainer>
            <Column
                width={isMobile ? '90%' : '75%'}
                bgColor="white"
            >
                <Block pv="XXXXL" alignItems="center">
                    <Icon
                        iconName="medal@2x.png"
                        width={200}
                        alignSelf="center"
                    />
                </Block>

                <ImageBackground
                    width="100%"
                    height={isMobile ? '90px' : '12vh'}
                    imageName="cloudsHeader@2x.png"
                />

                <Block
                    pt="Z"
                    pb="G"
                    ph="XXL"
                    bgColor="blueLight3"
                    alignItems="center"
                    style={{ marginTop: '-5px' }}
                >
                    <Circle
                        radius={CIRCLE_SIZE}
                        alignItems="center"
                        justifyContent="center"
                        bgColor="white"
                    >
                        <Icon
                            iconName={`${profile.avatar}@2x.png`}
                            alt="mask"
                            height={MASK_SIZE}
                            width={MASK_SIZE}
                            alignSelf="center"
                        />
                    </Circle>
                    <Spacer size="L" />

                    <Text uppercase size="XL">
                        {t('forestWidget.forestOf.title', { name: profile.nickname })}
                    </Text>
                    <Spacer size="XL" />

                    <Globe
                        imageName={(treesPlantedTribe + TREES_OFFSET) > 30 ? 'globeWithTrees@2x.png' : 'globeEmpty@2x.png'}
                        trees={treesPlantedTribe + TREES_OFFSET}
                        alignSelf="center"
                    />
                    <Spacer size="XL" />

                    <SplitFlapDisplay
                        number={treesPlantedTribe + TREES_OFFSET}
                        length={6}
                        size={setSize('S', 'XS')}
                        alignSelf="center"
                    />
                    <Spacer size="L" />
                    <Text size="M" center>
                        {t('forestWidget.treesPlantedComunity.title')}
                    </Text>
                </Block>

                <Block
                    pv="XXXL"
                    ph="XXL"
                    alignItems="center"
                >
                    <Text
                        tag="h2"
                        size="XL"
                        center
                    >
                        {t('forestWidget.weAre.title', { members: invitedUsers })}
                    </Text>
                    <Spacer size="XXXXL" />

                    <Text
                        tag="h2"
                        uppercase
                        center
                    >
                        {t('forestWidget.joinMe.title')}
                    </Text>
                    <Spacer size="XL" />
                    <Button
                        tag="a"
                        variant="info"
                        href={invitationLink}
                        title={t('forestWidget.plantFirstTree.title')}
                        style={{ maxWidth: isMobile ? '100%' : '60%' }}
                    />

                    <Spacer size="G" />
                    <Text uppercase size="XS" semibold color="grey3" space="L">
                        {t('forestWidget.shareIt.title')}
                    </Text>
                    <Share theme="dark" shareContent={shareContent} />
                </Block>
            </Column>
        </MainContainer>
    )
}

export default ForestWidget
